import { render, staticRenderFns } from "./userListModel.vue?vue&type=template&id=51127d0e&"
import script from "./userListModel.vue?vue&type=script&lang=js&"
export * from "./userListModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports